import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

const ANNOTATION = 'github.com/project-slug';
const FACET = `metadata.annotations.${ANNOTATION}`;

class EntityRepoFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityRepoPicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      repo: EntityRepoFilter;
    }
  >
    label="Repo"
    name="repo"
    path={FACET}
    Filter={EntityRepoFilter}
  />
);
